import defaultsDeep from 'lodash-es/defaultsDeep';
import { DeepPartial } from '@df/util/type/deep-partial';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { NThumbor } from './df-thumbor.interface';
import { ThumborResizeService } from './thumbor-resize.service';
import { ResizeService } from '@df/ui/common/resize.service';

export function provideDfModuleThumbor(config?: DeepPartial<NThumbor.IModuleOptions>): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: ResizeService, useExisting: ThumborResizeService },
        {
            provide: NThumbor.OPTIONS,
            useFactory: () =>
                defaultsDeep(config || {}, {
                    defaultOptions: {
                        fillColor: 'white',
                        upscale: true
                    }
                })
        }
    ]);
}
